import { h } from '../lib/dom';

export function renderManifesto(): HTMLElement {
  const quote = h('blockquote', { class: 'manifesto-quote reveal' });
  quote.innerHTML =
    'We believe curiosity is a public good, and the work of nurturing it belongs to all of us having <em>fun</em>. And fun is the important key for all of us to achieve anything.';

  return h('section', { class: 'manifesto', 'aria-label': 'Manifesto' },
    h('div', { class: 'container' }, quote),
  );
}
